//////////////////////////////////////////////////
//// Interface:
//////////////////////////////////////////////////
export interface MotionPreferenceOptions
{
  /**
   * // Option: ユーザーの「動きを減らす」設定を尊重するか
   *
   * true の場合、OS/ブラウザが prefers-reduced-motion: reduce を返す環境では、
   * UI側のアニメーションを省略し、即時切り替えへ寄せます。
   */
  respectUserMotionPreference?: boolean;
}
